import { render, staticRenderFns } from "./PriceWidget.vue?vue&type=template&id=5805b610&scoped=true"
import script from "./PriceWidget.vue?vue&type=script&lang=js"
export * from "./PriceWidget.vue?vue&type=script&lang=js"
import style0 from "./PriceWidget.vue?vue&type=style&index=0&id=5805b610&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5805b610",
  null
  
)

export default component.exports